import { IPopupTriggerAction, PopupState } from "../types/popup"
import PopupActionTypes from "../actionTypes/popup"

export const popupTriggerActionCreator = (popupState: PopupState): IPopupTriggerAction => {
  return {
    type: PopupActionTypes.POPUP_TRIGGER,
    payload: popupState,
  }
}
